"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarWrapper = exports.CancelDisabledWrapper = exports.StyledBanner = exports.ErrorPageContentWrapper = exports.ErrorHeading = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const breakpoints_1 = require("../../../lib/constants/breakpoints");
const banner_1 = __importDefault(require("@kyruus/banner"));
// Adapted from PageHeading in direct-book-widget/components/header/styles.jsx
exports.ErrorHeading = styled_1.default.div `
  display: inline-flex;
  width: 100%;
  align-items: center;
  min-height: 62px;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px ${(0, ui_theme_1.fromTheme)('spacing_small')} 0px;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  @media screen and ${(0, ui_theme_1.fromTheme)('screen_medium')} {
    min-height: 70px;
    margin-top: 13px;
    margin-bottom: 0px;
  }
  & > svg:first-of-type {
    min-height: ${(0, ui_theme_1.fromTheme)('font_size_heading_1')};
    min-width: ${(0, ui_theme_1.fromTheme)('font_size_heading_1')};
    margin: 0px ${(0, ui_theme_1.fromTheme)('spacing_small')} 5px 0px;
    color: ${(0, ui_theme_1.fromTheme)('color_warning')};
  }
  & > span {
    flex-grow: 1;
  }
`;
exports.ErrorPageContentWrapper = styled_1.default.div `
  padding-bottom: 0px;
  margin-bottom: 40px;
`;
exports.StyledBanner = (0, styled_1.default)(banner_1.default) `
  padding-bottom: 0px;
  > div {
    padding-bottom: 0px;
  }
`;
exports.CancelDisabledWrapper = styled_1.default.div `
  max-width: ${breakpoints_1.SIDEBAR_WIDTH};
  margin: auto;
  @media only screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    max-width: none;
    display: flex;
    justify-content: space-around;
  }
`;
exports.SideBarWrapper = styled_1.default.div `
  @media only screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin-left: 50px;
  }
`;
//# sourceMappingURL=styles.js.map